<template>
  <div class="space-ba-xxl" id="projekte-links">
    <!-- <h2 class="space-ba-xs">Projekte</h2> -->

    <!-- EINLEITUNG PROJEKTE LINKS -->
    <div class="space-ba-s" v-html="newLineText(entries.einleitungProjekte)"></div>

    <!-- PROJEKTE LINKS -->
    <div class="link-arrow-wrapper border-b" :class="{'border-t': i == 0}" v-for="(item, i) in entries.projekteLinks" :key="i">
      <router-link class="link-arrow-a type-xs" :to="'/projekte/' + item.slug">{{item.title}}</router-link>
      <svg class="link-arrow-icon" width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-575.000000, -3298.000000)" fill="#20377A" fill-rule="nonzero">
            <polygon points="577.3 3319.404 593.572 3303.168 593.572 3314.4 596.164 3314.4 596.164 3298.632 580.396 3298.632 580.396 3301.224 591.592 3301.224 575.356 3317.496"></polygon>
          </g>
        </g>
      </svg>
    </div>

  </div>
</template>

<script>
export default {
  name: "ProjekteLinks",
  props: {
    entries: Object,
  },
  methods: {
    newLineText(el) {
      if (el) {
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  div.link-arrow-wrapper {
    padding-top: 1.6rem;
    padding-bottom: 1.5rem;
    position: relative;
    & a, & svg {
      display: block;
    }
  }

  svg.link-arrow-icon {
    width: 1.0rem;
    position: absolute;
    top: 1.6rem;
    right: 0;
  }
  
</style>